import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const searchMembers = async (setData, companyId, name, page) => {
  return await axios.get(`companies/${companyId}/members/search-page?name=${encodeURIComponent(name)}&page=${page}`)
    .then((response) => {
      setData(response.data.data);
      return response.data.data.content;
    })
    .catch(() => {});
};

export default searchMembers;